var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhoServe3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 295,
    height: 132,
    viewBox: "0 0 295 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4087 17.515L0 0.211477C1.22725 33.6354 0.458315 102.223 0.920437 110.688C1.38066 119.118 10.585 131.036 21.6303 131.097C101.708 131.541 264.55 132.885 274.75 131.097C284.875 129.322 293.159 117.787 295 112.019V0L276 17.5C275.847 46.9308 276.619 101.21 276.131 104.033C275.671 106.695 271.682 110.54 269.228 112.019C191.297 112.019 33.8582 112.42 27.6131 112.019C20.7098 111.575 18.869 105.512 18.4087 102.258V17.515Z",
    fill: "#DD9326"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhoServe3);
export default __webpack_public_path__ + "static/media/who_serve_3.80d57c19f478935bfb8f321f40ae5c2a.svg";
export { ForwardRef as ReactComponent };